export const DEFINITION_ENDPOINT_URL = "https://us-central1-te-reo-pronounciation-guide.cloudfunctions.net/function-1";